import { render, staticRenderFns } from "./TitleItem.vue?vue&type=template&id=273be5fd&scoped=true&"
import script from "./TitleItem.vue?vue&type=script&lang=js&"
export * from "./TitleItem.vue?vue&type=script&lang=js&"
import style0 from "./TitleItem.vue?vue&type=style&index=0&id=273be5fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273be5fd",
  null
  
)

export default component.exports